import Div from "@jumbo/shared/Div";
import React, { useEffect } from "react";
import { Button, Divider, FormControl, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useAppMutation } from "../../../../services";
import teacherServices from "../../../../services/teacher-services";

const Evaluation = ({ setShowEvaluation, evaluation, firstName }) => {
  const [values, setValues] = React.useState({});
  const { t } = useTranslation();

  const {
    mutate: loadTeachers,
    isSuccess,
    isError,
    data,
  } = useAppMutation(teacherServices.loadTeachers);

  useEffect(() => {
    if (evaluation) {
      loadTeachers();
    }
  }, [evaluation]);

  useEffect(() => {
    if (isSuccess) {
      console.log("Teachers...", data);
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (evaluation) {
      setValues({ evaluation: evaluation });
      console.log("evaluation----", evaluation);
    }
  }, [evaluation]);

  return (
    <Div
      sx={{
        width: "100%",
        minHeight: 100,
        minWidth: { xs: "90%", sm: 400, md: 500 },
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          color: "#002F6C",
          mb: 2,
          fontSize: "1.3rem",
          borderBottom: "3px solid #002F6C", // underline effect
          pb: 0.5,
          width: "fit-content", // shrink to content
          mx: "auto",
        }}
      >
        {t("feedbackForm.info2")} {firstName}
      </Typography>

      {/* Overall Comment */}
      <div>
        <Typography sx={{ fontWeight: "bold", mb: 0.5, color: "#002F6C" }}>
          {t("evaluation-form.overall")}:
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={1}
          maxRows={10}
          value={values.evaluation?.importantInformation || "-"}
          disabled
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            mb: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#002F6C", // keep text black when disabled
            },
            "& .MuiInputBase-input": {
              scrollbarWidth: "thin",
              scrollbarColor: "#FF7F32 #FFF5E5", // Firefox
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#FF7F32", // orange scroll
                borderRadius: "8px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#FFF5E5",
              },
            },
          }}
          variant="outlined"
        />
      </div>

      {/* Actual Level */}

      <Div
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          mb: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            whiteSpace: "nowrap",
            mr: 1,
            color: "#002F6C",
          }}
        >
          {t("evaluation-form.actualLevel")}:
        </Typography>

        <TextField
          fullWidth
          value={values.evaluation?.actualLevel2?.label || "---"}
          disabled
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#002F6C", // keep text black when disabled
            },
          }}
          variant="outlined"
          size="small"
        />
      </Div>

      {/* Objective Level */}

      <Div
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          mb: 2,
        }}
      >
        {/* Label */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            whiteSpace: "nowrap",
            mr: 1,
            color: "#002F6C",
          }}
        >
          {t("evaluation-form.targetLevel")}:
        </Typography>

        {/* Value Box */}
        <TextField
          fullWidth
          value={values.evaluation?.objectiveLevel2?.label || "---"}
          disabled
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#002F6C", // keep text black when disabled
            },
          }}
          variant="outlined"
          size="small"
        />
      </Div>

      {/* Book Recommended */}

      <Div
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          mb: 2,
        }}
      >
        {/* Label */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            whiteSpace: "nowrap",
            mr: 1,
            color: "#002F6C",
          }}
        >
          {t("evaluation-form.booksRecommended")}:
        </Typography>

        {/* Value Box */}
        <TextField
          fullWidth
          value={
            values.evaluation?.booksRecommended &&
            values.evaluation?.booksRecommended.length > 0
              ? values.evaluation?.booksRecommended
              : "---"
          }
          disabled
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#002F6C", // keep text black when disabled
            },
          }}
          variant="outlined"
          size="small"
        />
      </Div>

      {/* Teachers Recommended */}

      <div>
        <Typography sx={{ fontWeight: "bold", mb: 0.5, color: "#002F6C" }}>
          {t("evaluation-form.teachersRecommended")}:
        </Typography>

        <TextField
          fullWidth
          value={
            values.evaluation?.teachersRecommended &&
            values.evaluation.teachersRecommended.length > 0
              ? values.evaluation.teachersRecommended
                  .map((id) => {
                    const teacher = data?.teachers?.find(
                      (t) => t.teacherId === id,
                    );
                    return teacher
                      ? `${teacher.firstName} ${teacher.lastName}`
                      : id; // fallback if teacher not found
                  })
                  .join("\n")
              : "No teachers recommended"
          }
          disabled
          multiline
          minRows={1} // 🔑 will auto-grow but never shrink smaller than 1 row
          maxRows={10} // optional limit so it doesn’t get too tall
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            mb: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#002F6C", // keep text black
            },
          }}
          variant="outlined"
        />
      </div>

      {/*<div>
        <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
          Teachers recommended:
        </Typography>

        <TextField
          fullWidth
          value={
            values.evaluation?.teachersRecommended &&
            values.evaluation?.teachersRecommended.length > 0
              ? values.evaluation.teachersRecommended
              : "No teachers recommended"
          }
          disabled
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            mb: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000", // force black text when disabled
            },
          }}
          variant="outlined"
        />
      </div>*/}

      {/* Program Frequency */}

      <Div
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          mb: 2,
        }}
      >
        {/* Label */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            whiteSpace: "nowrap",
            mr: 1,
            color: "#002F6C",
          }}
        >
          {t("evaluation-form.frequencyRecommended")}:
        </Typography>

        {/* Value Box */}
        <TextField
          fullWidth
          value={
            values.evaluation?.programFrequencyRecommended &&
            values.evaluation?.programFrequencyRecommended.length > 0
              ? values.evaluation?.programFrequencyRecommended
              : "---"
          }
          disabled
          sx={{
            bgcolor: "#FFF5E5",
            borderRadius: 2,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#002F6C", // keep text black when disabled
            },
          }}
          variant="outlined"
          size="small"
        />
      </Div>

      {/* Back Button */}
      <Div sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          onClick={() => setShowEvaluation(false)}
          sx={{
            textTransform: "none",
            backgroundColor: "#2d6bbf", // standard MUI red
            color: "#fff",
            "&:hover": {
              bgcolor: "#265ca6", // darker red on hover
            },
          }}
        >
          {t("common.backBtn")}
        </Button>
      </Div>
    </Div>
  );
};

export default Evaluation;
